/**
 * @purpose: mengelola form transaksi purchase order termasuk validasi trigger reason, pembatasan qty PO, reset form, dan pencegahan double save.
 * @called_by: views/app_po/po_entry.html.
 * @deps: AngularJS app, urlServices, modalService, modalFactory, toaster, API /api/purchase-reason-codes, API /api/report/purchase-history-settings.
 * @public: poTrxCtrl.
 * @side_effects: memuat master reason code, memvalidasi reason PO, membatasi qty berdasarkan sisa PR, mereset form entry, dan menahan save ganda.
 */
app
    .controller('poTrxCtrl', ['$rootScope', '$scope', '$state', '$location', '$filter', 'urlServices', 'modalService', 'modalFactory', 'toaster', '_VAR_GLOBAL', function ($rootScope, $scope, $state, $location, $filter, urlServices, modalService, modalFactory, toaster, _VAR_GLOBAL) {
        if ($rootScope.globalFormatDateRangePickerSingleTimeOption && $rootScope.globalFormatDateRangePickerSingleTimeOption.minDate) {
            delete $rootScope.globalFormatDateRangePickerSingleTimeOption["minData"];
        };

        console.log(urlServices.getUrlParameter('pr'))

        var defaultJournal = {
            Satuan: "PCS",
            HargaSystem: 0,
            HargaSatuan: 0,
            KodeItem: '',
            NamaItem: '',
            SubKategori: '',
            SubKategoriBarang: '',
            previousPrice: 0,
            referencePrice: 0,
            previousPurchaseDate: null,
            isReasonTracked: false,
            Qty: 1,
            QtyMax: null,
            SubTotal: 0.00,
            reasonCode: '',
            reasonDetail: '',
            reasonName: '',
            priceStatus: 'BARU',
            requiresReason: false
        };
        $scope.detailJournal = [];
        $scope.reasonCodeOptions = [];
        $scope.reasonCodeLoading = false;
        $scope.poReasonSettings = {
            loaded: false,
            subKategoriValues: [],
            categoryCodes: []
        };
        $scope.data = {
            Tanggal: moment()._d,
            TanggalButuh: moment()._d,
            DiscPersen: 0,
            Disc: 0,
            SubTotalDisc: 0,
            NilaiPPN: 0,
            PPnPersen: 0,
            Total: 0
        };
        $scope.isEdit = false;
        $scope.isSaving = false;
        $scope.isConfirmingSave = false;

        $scope.detailData = {};
        $scope.getIndex = null;

        function resetEntryFormState() {
            $scope.errorMessage = null;
            $scope.getIndex = null;
            if ($scope.frmExpenseTrx) {
                $scope.frmExpenseTrx.$setPristine();
                $scope.frmExpenseTrx.$setUntouched();
            }
        }

        function normalizeTextValue(value) {
            return String(value === undefined || value === null ? '' : value).trim();
        }

        function normalizeSubKategoriValue(value) {
            var normalized = String(value === undefined || value === null ? '' : value).trim().toUpperCase();

            if (normalized === 'SERVICE') {
                normalized = 'JASA';
            }

            return normalized;
        }

        function normalizeCategoryCodeValue(value) {
            return String(value === undefined || value === null ? '' : value).trim().toUpperCase();
        }

        function normalizeUniqueValues(list, normalizer) {
            var unique = {};
            var output = [];

            angular.forEach(Array.isArray(list) ? list : [], function (item) {
                var normalized = normalizer(item);

                if (!normalized || unique[normalized]) {
                    return;
                }

                unique[normalized] = true;
                output.push(normalized);
            });

            return output;
        }

        function hasPoReasonFilter(settings) {
            var source = settings || $scope.poReasonSettings || {};
            return !!((source.subKategoriValues && source.subKategoriValues.length) || (source.categoryCodes && source.categoryCodes.length));
        }

        function normalizePoReasonSettings(raw) {
            var source = raw || {};

            return {
                loaded: true,
                subKategoriValues: normalizeUniqueValues(source.poReasonSubKategoriValues || source.subKategoriValues || [], normalizeSubKategoriValue),
                categoryCodes: normalizeUniqueValues(source.poReasonCategoryCodes || source.categoryCodes || [], normalizeCategoryCodeValue)
            };
        }

        function getRowSubKategori(row) {
            return normalizeSubKategoriValue(row && (row.SubKategoriBarang || row.SubKategori || row.subKategoriBarang || row.subKategori));
        }

        function getRowCategoryCode(row) {
            return normalizeCategoryCodeValue(row && (row.KodeItem || row.kodeItem));
        }

        function hasReasonTrackingMetadata(row) {
            return !!(getRowSubKategori(row) || getRowCategoryCode(row));
        }

        function resolveTrackedBySettings(row) {
            var settings = $scope.poReasonSettings || {};
            var rowSubKategori = getRowSubKategori(row);
            var rowCategoryCode = getRowCategoryCode(row);

            if (!settings.loaded) {
                return row && row.isReasonTracked === false ? false : true;
            }
            if (!hasPoReasonFilter(settings)) {
                return true;
            }
            if (settings.subKategoriValues.length > 0 && settings.subKategoriValues.indexOf(rowSubKategori) < 0) {
                return false;
            }
            if (settings.categoryCodes.length > 0 && settings.categoryCodes.indexOf(rowCategoryCode) < 0) {
                return false;
            }

            return true;
        }

        function syncTrackedFlag(row) {
            if (!row) {
                return;
            }
            if (!hasReasonTrackingMetadata(row)) {
                if (row.isReasonTracked === undefined || row.isReasonTracked === null) {
                    row.isReasonTracked = false;
                }
                return;
            }

            row.isReasonTracked = resolveTrackedBySettings(row);
        }

        function normalizeNumberValue(value, fallback) {
            var parsed = parseFloat(value);

            if (isNaN(parsed)) {
                return typeof fallback === 'number' ? fallback : 0;
            }

            return parsed;
        }

        function buildPrQtyKey(row) {
            var prNo = normalizeTextValue(row && row.no_pr).toUpperCase();
            var kodeBarang = normalizeTextValue(row && row.KodeBarang).toUpperCase();

            if (!prNo || !kodeBarang) {
                return '';
            }

            return prNo + '|' + kodeBarang;
        }

        function resolveQtyMaxValue(row) {
            var maxQty = normalizeNumberValue(row && row.QtyMax, NaN);

            return isNaN(maxQty) ? 0 : maxQty;
        }

        function enforceQtyMax(row, silent) {
            var maxQty = resolveQtyMaxValue(row);
            var currentQty;

            if (!row || !normalizeTextValue(row.no_pr) || maxQty <= 0) {
                return false;
            }

            currentQty = normalizeNumberValue(row.Qty, 0);
            if (currentQty <= maxQty + 0.0001) {
                return false;
            }

            row.Qty = maxQty;
            if (!silent) {
                toaster.pop('warning', 'Purchase Order', 'Qty PO tidak boleh lebih dari qty PR untuk ' + (row.NamaBarang || row.KodeBarang || row.no_pr));
            }

            return true;
        }

        function normalizeDateKey(value) {
            var dateValue;

            if (!value) {
                return '';
            }

            if (value._d) {
                value = value._d;
            }

            dateValue = new Date(value);
            if (isNaN(dateValue.getTime())) {
                return '';
            }

            return moment(dateValue).format('YYYYMMDD');
        }

        function resolvePoDateValue() {
            return ($scope.data && $scope.data.Tanggal && $scope.data.Tanggal._d) ? $scope.data.Tanggal._d : ($scope.data && $scope.data.Tanggal) || new Date();
        }

        function hasPreviousPurchaseHistory(row) {
            return !!(row && (row.previousPurchaseDate || normalizeTextValue(row.previousPONo) || normalizeTextValue(row.previousVendor)));
        }

        function resolveReferencePrice(row) {
            var currentPrice = normalizeNumberValue(row && (row.HargaSatuan !== undefined ? row.HargaSatuan : row.currentPrice), 0);
            var previousPrice = normalizeNumberValue(row && row.previousPrice, NaN);
            var referencePrice = normalizeNumberValue(row && row.referencePrice, NaN);
            var systemPrice = normalizeNumberValue(row && row.HargaSystem, currentPrice);
            var hasHistory = hasPreviousPurchaseHistory(row);

            if (!isNaN(previousPrice) && (hasHistory || Math.abs(previousPrice) > 0.0001)) {
                return previousPrice;
            }

            if (!isNaN(referencePrice) && (hasHistory || Math.abs(referencePrice) > 0.0001)) {
                return referencePrice;
            }

            return systemPrice;
        }

        function resolveCurrentPriceValue(row) {
            return normalizeNumberValue(row && (row.HargaSatuan !== undefined ? row.HargaSatuan : row.currentPrice), 0);
        }

        function findReasonCode(reasonCode) {
            var code = normalizeTextValue(reasonCode).toUpperCase();
            var foundItem = null;

            angular.forEach($scope.reasonCodeOptions || [], function (item) {
                if (!foundItem && normalizeTextValue(item && item.reasonCode).toUpperCase() === code) {
                    foundItem = item;
                }
            });

            return foundItem;
        }

        function resolvePriceStatus(row) {
            var currentPrice = resolveCurrentPriceValue(row);
            var referencePrice = resolveReferencePrice(row);
            var poDateKey = normalizeDateKey(resolvePoDateValue());
            var previousDateKey = normalizeDateKey(row && row.previousPurchaseDate);

            if (!previousDateKey && Math.abs(currentPrice - referencePrice) < 0.0001) {
                previousDateKey = poDateKey;
            }

            if (poDateKey && previousDateKey && poDateKey === previousDateKey && Math.abs(currentPrice - referencePrice) < 0.0001) {
                return 'BARU';
            }
            if ((currentPrice - referencePrice) < -0.0001) {
                return 'TURUN';
            }
            if ((currentPrice - referencePrice) > 0.0001) {
                return 'NAIK';
            }
            if (Math.abs(currentPrice - referencePrice) < 0.0001) {
                return 'STABIL';
            }

            return 'BARU';
        }

        $scope.getReferencePrice = function (row) {
            return resolveReferencePrice(row);
        };

        $scope.getCurrentPrice = function (row) {
            return resolveCurrentPriceValue(row);
        };

        $scope.getPreviousPurchaseInfo = function (row) {
            var info = [];
            var previousPONo = normalizeTextValue(row && row.previousPONo);
            var previousPurchaseDate = row && row.previousPurchaseDate ? new Date(row.previousPurchaseDate) : null;

            if (previousPONo) {
                info.push(previousPONo);
            }

            if (previousPurchaseDate && !isNaN(previousPurchaseDate.getTime())) {
                info.push(moment(previousPurchaseDate).format('DD-MM-YYYY'));
            }

            return info.join(' | ');
        };

        $scope.syncReasonState = function (row) {
            var selectedReason;

            if (!row) {
                return;
            }

            syncTrackedFlag(row);

            if (row.isReasonTracked === false) {
                row.referencePrice = resolveCurrentPriceValue(row);
                row.previousPrice = row.referencePrice;
                row.currentPrice = resolveCurrentPriceValue(row);
                row.previousPurchaseDate = row.previousPurchaseDate || resolvePoDateValue();
                row.priceStatus = 'BARU';
                row.requiresReason = false;
                row.reasonCode = '';
                row.reasonDetail = '';
                row.reasonName = '';
                return;
            }

            row.referencePrice = resolveReferencePrice(row);
            row.previousPrice = row.referencePrice;
            row.currentPrice = resolveCurrentPriceValue(row);
            row.priceStatus = resolvePriceStatus(row);
            row.requiresReason = row.priceStatus === 'NAIK' || row.priceStatus === 'TURUN';
            if (!row.requiresReason) {
                row.reasonCode = '';
                row.reasonDetail = '';
                row.reasonName = '';
                return;
            }

            selectedReason = findReasonCode(row.reasonCode);
            row.reasonName = selectedReason ? selectedReason.reasonName : '';
        };

        $scope.refreshReasonState = function () {
            angular.forEach($scope.detailJournal || [], function (item) {
                $scope.syncReasonState(item);
            });
        };

        $scope.requiresReason = function (row) {
            return !!(row && row.requiresReason);
        };

        $scope.onReasonCodeChange = function (row) {
            $scope.syncReasonState(row);
        };

        $scope.$watch('data.Tanggal', function () {
            $scope.refreshReasonState();
        });

        $scope.loadReasonCodes = function () {
            $scope.reasonCodeLoading = true;
            urlServices.ambilData('api/purchase-reason-codes', {}, function (err, result) {
                $scope.reasonCodeLoading = false;
                if (err) {
                    return toaster.pop('error', 'Purchase Order', err.err || err || 'Master reason code tidak dapat dimuat');
                }

                $scope.reasonCodeOptions = (result || []).filter(function (item) {
                    return item && item.reasonCode;
                });
                $scope.refreshReasonState();
            });
        };

        $scope.loadReasonSettings = function () {
            return urlServices.ambilData('api/report/purchase-history-settings', {}, function (err, result) {
                var responseData = result && result.data ? result.data : result;

                if (err) {
                    $scope.poReasonSettings = {
                        loaded: true,
                        subKategoriValues: [],
                        categoryCodes: []
                    };
                    $scope.refreshReasonState();
                    return;
                }

                $scope.poReasonSettings = normalizePoReasonSettings(responseData || {});
                $scope.refreshReasonState();
            });
        };

        $scope.validateReasonRows = function () {
            var missingRows = [];

            $scope.refreshReasonState();
            angular.forEach($scope.detailJournal || [], function (item, index) {
                if (!item || !item.requiresReason) {
                    return;
                }
                if (!normalizeTextValue(item.reasonCode) || !normalizeTextValue(item.reasonDetail)) {
                    var label = 'row ' + (index + 1);
                    if (item.KodeBarang) label += ' [' + item.KodeBarang + ']';
                    if (item.NamaBarang) label += ' (' + item.NamaBarang + ')';
                    missingRows.push(label);
                }
            });

            if (missingRows.length > 0) {
                toaster.pop('warning', 'Purchase Order', 'Reason code dan reason detail wajib diisi pada ' + missingRows.join(', '));
                return false;
            }

            return true;
        };

        $scope.validatePrQtyRows = function () {
            var groupedRows = {};
            var invalidRows = [];

            angular.forEach($scope.detailJournal || [], function (item, index) {
                var rowKey = buildPrQtyKey(item);
                var maxQty;

                if (!item || !rowKey) {
                    return;
                }

                maxQty = resolveQtyMaxValue(item);
                if (maxQty <= 0) {
                    return;
                }

                if (!groupedRows[rowKey]) {
                    groupedRows[rowKey] = {
                        qty: 0,
                        maxQty: maxQty,
                        label: (item.no_pr || '-') + ' / ' + (item.NamaBarang || item.KodeBarang || ('row ' + (index + 1)))
                    };
                }

                groupedRows[rowKey].qty += normalizeNumberValue(item.Qty, 0);
                if (maxQty > groupedRows[rowKey].maxQty) {
                    groupedRows[rowKey].maxQty = maxQty;
                }
            });

            angular.forEach(groupedRows, function (item) {
                if (item.qty > item.maxQty + 0.0001) {
                    invalidRows.push(item.label);
                }
            });

            if (invalidRows.length > 0) {
                toaster.pop('warning', 'Purchase Order', 'Qty PO tidak boleh lebih dari qty PR pada ' + invalidRows.join(', '));
                return false;
            }

            return true;
        };


        $scope.savePO = function () {
            if ($scope.isSaving || $scope.isConfirmingSave) {
                return;
            }

            $scope.isConfirmingSave = true;
            modalService.showModal({}, {
                    closeButtonText: 'No',
                    actionButtonText: 'Yes',
                    headerText: 'New',
                    bodyText: 'Simpan Purchase Order?'
                })
                .then(function (result) {
                    $scope.isConfirmingSave = false;
                    if (result) {
                        $scope.isSaving = true;
                        console.log(new Date($scope.data.Tanggal));
                        if ($scope.data.Tanggal && $scope.data.Tanggal._d) {
                            console.log('with d');
                            $scope.data.Tanggal = $scope.data.Tanggal._d;
                        };
                        if ($scope.data.TanggalButuh && $scope.data.TanggalButuh._d) {
                            console.log('with d');
                            $scope.data.TanggalButuh = $scope.data.TanggalButuh._d;
                        };

                        console.log($scope.data);
                        console.log($scope.detailJournal);
                        $scope.hitung();
                        var qtyAdjusted = false;
                        angular.forEach($scope.detailJournal || [], function (item) {
                            if (enforceQtyMax(item, true)) {
                                qtyAdjusted = true;
                            }
                        });
                        if (qtyAdjusted) {
                            $scope.hitung();
                        }
                        if (!$scope.validatePrQtyRows()) {
                            $scope.isSaving = false;
                            return;
                        }
                        if (!$scope.validateReasonRows()) {
                            $scope.isSaving = false;
                            return;
                        }
                        $scope.data.TotalQty=$filter('sumByKey')($scope.detailJournal, 'Qty')
                        $scope.data.detail = angular.copy($scope.detailJournal);

                        if ($scope.isEdit){
                            urlServices.updateData('api/po', $scope.data, function (g, s) {
                                console.log(s);
                                console.log(g);
                                if (g) {
                                    if (g && g.err && g.err instanceof Array) {
                                        console.log('error');
                                        $scope.errorMessage = g.err;
                                        var elP = '';
                                        for (var key in $scope.errorMessage) {
                                            elP +=  $scope.errorMessage[key].msg;
                                        }
                                        console.log(elP)
                                        toaster.pop('error', 'error data', elP);
                                        $scope.isSaving = false;
                
                
                                    } else {
                                        toaster.pop('error', 'error data', g.err);
                                        $scope.isSaving = false;
                                        window.location=_API_URL+'purchasing?screen=prview';
                
                                    }
                                } else {
                                    
                                    toaster.pop('success', 'Success', 'Data disimpan');
                                    $scope.isSaving = false;
                                    window.location=_API_URL+'purchasing?screen=prview';
                                    
                
                
                                }
                
                            })
                        }else{
                            urlServices.simpanData('api/po', $scope.data, function (g, s) {
                                console.log(s);
                                console.log(g);
                                if (g) {
                                    if (g && g.err && g.err instanceof Array) {
                                        console.log('error');
                                        $scope.errorMessage = g.err;
                                        var elP = '';
                                        for (var key in $scope.errorMessage) {
                                            elP += $scope.errorMessage[key].msg;
                                        }
                                        console.log(elP)
                                        toaster.pop('error', 'error data', elP);
                                        $scope.isSaving = false;
    
    
                                    } else {
                                        toaster.pop('error', 'error data', g.err);
                                        $scope.isSaving = false;
                                        return window.location=_API_URL+'purchasing?screen=prview';
    
    
                                    }
                                } else {
    
                                    toaster.pop('success', 'Success', 'Data disimpan');
                                    $scope.addPO();
                                    $scope.isSaving = false;
    
    
    
                                }
    
                            })
                        }
                        
                    } else {
                        $scope.isSaving = false;
                    }
                }, function () {
                    $scope.isConfirmingSave = false;
                    $scope.isSaving = false;
                });

        };
        $scope.showItem = function (n) {
            console.log(n)
            $scope.getIndex = n;
            modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                functionName: 'itemList',
                params: {

                }

            });

            // modalForm.driverVendor();
        };
        $scope.showListVendor = function () {
            modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                functionName: 'vendorList',
                params: {

                }

            });
        }
        $scope.showListPRActive = function () {
		console.log('show ---pr');
                modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                functionName: 'pr-poList',
                params: {

                }
            });

        };
        $scope.getFromPr=function(No){
            console.log(No);
        };
        $scope.detailAdd = function () {
            $scope.detailJournal.push(angular.copy(defaultJournal));
            $scope.refreshReasonState();
        };
        $scope.detailRemove = function (x) {
            console.log(x);
            var index = $scope.detailJournal.indexOf(x);
            $scope.detailJournal.splice(index, 1);
            $scope.hitung();
        };
        $scope.addPO = function () {
            $scope.isEdit = false;
            $scope.isSaving = false;
            $scope.isConfirmingSave = false;
            $scope.pilihPrNo = null;
            $scope.data = {
                Tanggal: moment()._d,
                TanggalButuh: moment()._d,
                DiscPersen: 0,
                Disc:0,
                SubTotalDisc: 0,
                NilaiPPN: 0,
                PPnPersen: 0,
                Total: 0
            };
            $scope.detailJournal = [];
            $scope.detailJournal.push(angular.copy(defaultJournal));
            $scope.refreshReasonState();
            resetEntryFormState();
        };
        $scope.editPO=function(){
        
            // purchase-requisition/:prno/masterdetail
            urlServices.ambilData('api/po/' + $scope.data.NoBukti+'/masterdetail', {}, function (e, s) {
                console.log(s);
                if (e) {

                    toaster.pop('error', 'Error', e.err);
                      $scope.goBack();
                } else {
                    $scope.isEdit = true;
                    var master = s.master[0];
                    if (master && (master.is_approve || master.status === 'APPROVE')){
                        toaster.pop('error', 'Error', 'PO ini sudah di approve');
                        $scope.goBack();
                    }else{
                        $scope.data.NoBukti =master.NoBukti;
                        $scope.data.Tanggal=master.Tanggal;
                        $scope.data.TanggalButuh=master.TanggalButuh;
                        $scope.data.Keterangan=master.Keterangan;
                        $scope.data.PesanOleh=master.PesanOleh;
                        $scope.data.Vendor = master.Vendor;
                        $scope.data.Vendor_Name=master.Vendor_Name;
                        $scope.data.DiscPersen=master.DiscPersen;
                        $scope.data.PPnPersen=master.PPnPersen;
                        $scope.detailJournal=s.detail;
                        $scope.refreshReasonState();
                        $scope.hitung();
                    }
                }
            });
        };
        $scope.addFromPr = function (dt) {
            console.log('add form pr');
            $scope.data.NOPO = dt.master.NoBukti;
            $scope.data.PesanOleh=dt.master.PesanOleh;
            $scope.data.Keterangan=dt.master.Keterangan;
            console.log($scope.detailJournal);
            if ($scope.detailJournal.length==1 && !$scope.detailJournal[0].KodeBarang){
                $scope.detailJournal=[];
            };
            angular.forEach(dt.detail, function (key, value) {
                var remainingQty = Math.max(0, normalizeNumberValue(key.Qty, 0) - normalizeNumberValue(key.Qty_PO, 0));

                console.log(key);
                $scope.detailJournal.push({
                    KodeBarang: key.KodeBarang,
                    NamaBarang: key.NamaBarang,
                    KodeItem: key.KodeItem || key.kodeItem || '',
                    NamaItem: key.NamaItem || key.namaItem || '',
                    SubKategori: key.SubKategori || key.subKategori || key.SubKategoriBarang || key.subKategoriBarang || '',
                    SubKategoriBarang: key.SubKategoriBarang || key.subKategoriBarang || key.SubKategori || key.subKategori || '',
                    DescInt: key.DescInt,
                    DescExt: key.DescInt,
                    Satuan: key.Satuan,
                    Qty: remainingQty,
                    QtyMax: remainingQty,
                    HargaSystem:key.HargaSatuan,
                    HargaSatuan: key.HargaSatuan,
                    previousPrice: key.previousPrice,
                    referencePrice: key.referencePrice,
                    previousPurchaseDate: key.previousPurchaseDate,
                    previousPONo: key.previousPONo,
                    previousVendor: key.previousVendor,
                    isReasonTracked: key.isReasonTracked !== false,
                    no_pr:dt.master.NoBukti,
                    SubTotal: remainingQty * key.HargaSatuan,
                    reasonCode: '',
                    reasonDetail: '',
                    reasonName: '',
                    priceStatus: key.priceStatus || 'BARU'
                })
            });
            $scope.refreshReasonState();
            $scope.hitung();

        };
        $scope.$on('pilih-vendor', function (event, args) {
            console.log('pilih -vendor')
            $scope.data.Vendor=args.vendor.KodeCustomer;
            $scope.data.Vendor_Name=args.vendor.NamaCustomer;
        })
        $scope.$on('pilih-item', function (event, args) {
            console.log($scope.getIndex);
            console.log($scope.detailJournal);
            console.log('update');
            $scope.detailJournal[$scope.getIndex].KodeBarang = args.item.KodeBarang;
            $scope.detailJournal[$scope.getIndex].NamaBarang = args.item.NamaBarang;
            $scope.detailJournal[$scope.getIndex].KodeItem = args.item.KodeItem || args.item.kodeitem || '';
            $scope.detailJournal[$scope.getIndex].NamaItem = args.item.NamaItem || args.item.namaitem || '';
            $scope.detailJournal[$scope.getIndex].SubKategori = args.item.SubKategori || args.item.subKategori || args.item.SubKategoriBarang || args.item.subKategoriBarang || '';
            $scope.detailJournal[$scope.getIndex].SubKategoriBarang = args.item.SubKategoriBarang || args.item.subKategoriBarang || args.item.SubKategori || args.item.subKategori || '';
            $scope.detailJournal[$scope.getIndex].HargaSystem = args.item.HargaBeli;
            $scope.detailJournal[$scope.getIndex].HargaSatuan = args.item.HargaBeli;
            $scope.detailJournal[$scope.getIndex].Satuan = args.item.Satuan;
            $scope.detailJournal[$scope.getIndex].previousPrice = null;
            $scope.detailJournal[$scope.getIndex].referencePrice = null;
            $scope.detailJournal[$scope.getIndex].previousPurchaseDate = null;
            $scope.detailJournal[$scope.getIndex].previousPONo = '';
            $scope.detailJournal[$scope.getIndex].previousVendor = '';
            $scope.detailJournal[$scope.getIndex].isReasonTracked = resolveTrackedBySettings($scope.detailJournal[$scope.getIndex]);
            $scope.detailJournal[$scope.getIndex].Qty = $scope.detailJournal[$scope.getIndex].Qty ? $scope.detailJournal[$scope.getIndex].Qty : 1;
            $scope.priceQtyChange($scope.getIndex);
            $scope.getIndex = null;
            console.log($scope.detailJournal);
            console.log(args);
        });
        $scope.$on('pilih-driver-vendor', function (event, args) {
            console.log(args);
            $scope.data.contact_id = args.contact_id;
            $scope.data.contact_name = args.name;
        });
        $scope.$on('pilih-pr', function (event, args) {
            console.log(args);
            console.log('pilililili')
            $scope.pilihPrNo=args.pr.NoBukti;
           
            
                 urlServices.ambilData('api/po-pr/' + $scope.pilihPrNo, {}, function (e, s) {

                    console.log(s);
                    console.log(e);
                    if (e) {

                        toaster.pop('error', 'Error', e.data.err);
                        // $scope.addPO();
                    } else {
                        $scope.addFromPr(s);
                    }
                });
        })

        $scope.hitung = function () {
            var totalAmount = $filter('sumByKey')($scope.detailJournal, 'SubTotal');
            var taxAmount = 0;
            var discAmount=0;
            var totalDisc=0;
            var totalTax=0;
            $scope.data.SubTotal=totalAmount;
            if ($scope.data.DiscPersen) {
                discAmount = parseFloat($scope.data.DiscPersen || 0) / 100 * parseFloat(totalAmount);
                totalDisc=totalAmount - discAmount;
            } else {
                discAmount = 0;
                totalDisc=totalAmount;
            };
            if ($scope.data.PPnPersen) {
                taxAmount = parseFloat($scope.data.PPnPersen || 0) / 100 * parseFloat(totalDisc);
                totalTax=totalDisc + taxAmount;
            } else {
                taxAmount = 0;
                totalTax=totalDisc;
            };
            $scope.data.Disc = discAmount;
            $scope.data.SubTotalDisc=totalDisc;
            $scope.data.NilaiPPN=taxAmount;
            $scope.data.Total = totalTax;
        }

        $scope.priceQtyChange = function (x) {
            var dt = $scope.detailJournal[x];

            enforceQtyMax(dt);
            var price = dt.HargaSatuan || 0;
            var qt = dt.Qty || 0;
            $scope.detailJournal[x].SubTotal = parseFloat(price) * parseFloat(qt);
            $scope.syncReasonState($scope.detailJournal[x]);
            $scope.hitung();
            return true;
        };
        if (urlServices.getUrlParameter('isedit') == 'true') {
            $scope.data.NoBukti= urlServices.getUrlParameter('pono');
            $scope.editPO();
             
          
        } else {
            $scope.addPO();
        };
        $scope.loadReasonCodes();
        $scope.loadReasonSettings();
    }]);
